export async function getProductAnalytics(id) {
    const result = await fetch(`/api/product/get/analytics-by-id/${id}`);
    const body = await result.json()
    return body.product?.extensions?.newport?.analytics
}